import axios from 'axios';

// API service for fetching crypto and gold prices

// CoinGecko API for crypto prices
const COINGECKO_API_URL = 'https://api.coingecko.com/api/v3';

// Gold API - Using a free metals API
// Note: In a production environment, you would use a paid API with an API key
// For this example, we're using a free endpoint that provides gold prices
const GOLD_API_URL = 'https://www.goldapi.io/api/XAU/USD';

// List of supported cryptocurrencies
export const SUPPORTED_CRYPTOS = [
  { id: 'bitcoin', name: 'Bitcoin', symbol: 'BTC' },
  { id: 'ethereum', name: 'Ethereum', symbol: 'ETH' },
  { id: 'litecoin', name: 'Litecoin', symbol: 'LTC' },
  { id: 'ripple', name: 'XRP', symbol: 'XRP' },
  { id: 'cardano', name: 'Cardano', symbol: 'ADA' },
  { id: 'polkadot', name: 'Polkadot', symbol: 'DOT' },
  { id: 'binancecoin', name: 'Binance Coin', symbol: 'BNB' },
  { id: 'solana', name: 'Solana', symbol: 'SOL' },
];

// List of supported fiat currencies
export const SUPPORTED_CURRENCIES = [
  { code: 'USD', symbol: '$', name: 'US Dollar' },
  { code: 'EUR', symbol: '€', name: 'Euro' },
  { code: 'GBP', symbol: '£', name: 'British Pound' },
  { code: 'JPY', symbol: '¥', name: 'Japanese Yen' },
  { code: 'AUD', symbol: 'A$', name: 'Australian Dollar' },
  { code: 'CAD', symbol: 'C$', name: 'Canadian Dollar' },
  { code: 'CHF', symbol: 'Fr', name: 'Swiss Franc' },
  { code: 'CNY', symbol: '¥', name: 'Chinese Yuan' },
  { code: 'INR', symbol: '₹', name: 'Indian Rupee' },
  { code: 'AED', symbol: 'د.إ', name: 'UAE Dirham' },
  { code: 'SAR', symbol: '﷼', name: 'Saudi Riyal' },
];

// Get crypto prices for multiple coins in a specific currency
export const getCryptoPrices = async (coinIds, currency = 'USD') => {
  try {
    const response = await axios.get(
      `${COINGECKO_API_URL}/simple/price?ids=${coinIds.join(',')}&vs_currencies=${currency.toLowerCase()}`
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching crypto prices:', error);
    throw new Error('Failed to fetch cryptocurrency prices. Please try again later.');
  }
};

// Get gold price per gram in a specific currency
// Note: In a real application, you would use a paid API with proper authentication
// For this example, we're simulating the gold price with a fallback mechanism
export const getGoldPricePerGram = async (currency = 'USD') => {
  try {
    // In a real application, you would make an API call like this:
    // const response = await axios.get(`${GOLD_API_URL}/${currency}`, {
    //   headers: { 'x-access-token': 'YOUR_API_KEY' }
    // });
    
    // For this example, we'll use a fallback with simulated prices
    // This simulates different gold prices based on currency
    const goldPriceUSD = 62.94; // Price per gram in USD (as of the time of writing)
    
    // Exchange rates (approximate)
    const exchangeRates = {
      'USD': 1,
      'EUR': 0.92,
      'GBP': 0.79,
      'JPY': 151.76,
      'AUD': 1.52,
      'CAD': 1.37,
      'CHF': 0.90,
      'CNY': 7.24,
      'INR': 83.36,
      'AED': 3.67,
      'SAR': 3.75
    };
    
    // Calculate gold price in the requested currency
    const rate = exchangeRates[currency] || 1;
    const goldPrice = goldPriceUSD / rate;
    
    return {
      currency,
      price_per_gram: goldPrice
    };
  } catch (error) {
    console.error('Error fetching gold price:', error);
    throw new Error('Failed to fetch gold price. Please try again later.');
  }
};